import { createAsync } from '@solidjs/router';
import { Meta } from '@solidjs/meta';
import { Show, Suspense } from 'solid-js';
import { cachedGet } from '@troon/api-client';
import { FacilityCtx } from '../../../providers/facility';
import { getConfigValue } from '../../../modules/config';
import { ErrorBoundary } from '../../../components/error-boundary';
import { Revalidator } from '../../../providers/visibility';
import { NotFoundContent } from '../../../partials/404';
import type { Facility } from '../../../providers/facility';
import type { Accessor } from 'solid-js';
import type { RouteDefinition, RouteSectionProps } from '@solidjs/router';

export default function Facility(props: RouteSectionProps) {
	const facility = createAsync(() => getFacility({ path: { idOrSlug: props.params.facilityId! } }), {
		deferStream: true,
	});

	return (
		<Revalidator keys={['/v1/tee-times', '/v1/tee-times/{teeTimeId}']}>
			<Suspense>
				<ErrorBoundary content={<NotFoundContent withHero />}>
					{/* Important: split Shows for facility (resolved) vs facility is bookable to avoid throwing an initial 404 response even if the facility is bookable */}
					<Show when={facility()}>
						<Show when={facility()?.isBookable} fallback={<NotFoundContent withHero />}>
							<Meta
								name="og:image"
								content={`https://${getConfigValue('MAP_HOST')}/course/${props.params.facilityId}/og.jpg`}
							/>
							<FacilityCtx.Provider value={facility as Accessor<Facility>}>
								<ErrorBoundary>{props.children}</ErrorBoundary>
							</FacilityCtx.Provider>
						</Show>
					</Show>
				</ErrorBoundary>
			</Suspense>
		</Revalidator>
	);
}

export const route = {
	preload: (args) => getFacility({ path: { idOrSlug: args.params.facilityId! } }),
} satisfies RouteDefinition;

const getFacility = cachedGet('/v0/facilities/{idOrSlug}');
